import React from 'react';
import Home from "./screen/home/home";
import Post from "./screen/post/post";
import Page from "./screen/page/page";
import Blog from "./screen/blog/blog";
import Introduction from "./screen/introduction/introduction";
import Gallery from "./screen/gallery/gallery";
import ReportCard from "./screen/reportCard/reportCard";
import"./index.css"
import {Helmet} from "react-helmet";
import icon from  "../src/res/img/logo.png"
import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {Provider} from 'react-redux'
import {store, persistor} from '../src/redux/store/store'
import {PersistGate} from 'redux-persist/integration/react'
import Experience from "./screen/experience/experience";



const App = () => {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <Router>
                    <Helmet>
                        <title>{"آموزشگاه آنلاين زبان هلندي"}</title>
                        <meta name="description" content={"آموزشگاه آنلاين زبان هلندي"}/>
                        <meta name="apple-mobile-web-app-title" content="زبان هلندی"/>
                        <meta name="apple-mobile-web-app-capable" content="yes"/>
                        <meta name="google-site-verification" content="UuCr3ogH4Kbe9Gyzr61yu0w11y_LsEtRa0ciLOd6RVE" />
                        <link rel="canonical" href={`آموزشگاه آنلاين زبان هلندي`}/>
                        <link rel="apple-touch-startup-image" href="./res/img/logo.png" />
                        <link rel="app-touch-icon"  href="./res/img/logo.png"/>
                    </Helmet>
                    <Switch>
                        <Route exact path={"/"} component={Home}/>
                        <Route exact path={"/blog"} component={Blog}/>
                        <Route exact path={"/page/:id/:slu?"} component={Page}/>
                        <Route exact path={"/blog/:id"} component={Post}/>
                        <Route exact path={"/blog/category/:id"} component={Blog}/>
                        <Route exact path={"/introduction/:id"} component={Post}/>
                        <Route exact path={"/introduction"} component={Introduction}/>
                        <Route exact path={"/gallery"} component={Gallery}/>
                        <Route exact path={"/gallery/:id"} component={Post}/>
                        <Route exact path={"/gallery/category/:id"} component={Gallery}/>
                        <Route exact path={"/report-card"} component={ReportCard}/>
                        <Route exact path={"/experience"} component={Experience}/>
                        <Route exact path={"/gallery/report-card/:id"} component={Post}/>
                        <Route exact path={"/experience/:id"} component={Post}/>
                        <Route exact path={"/report-card/category/:id"} component={ReportCard}/>
                        <Route exact path={"/experience/category/:id"} component={Experience}/>
                    </Switch>
                </Router>
                <ToastContainer
                    position="bottom-center"
                    autoClose={5000}
                    hideProgressBar={true}
                    newestOnTop={false}
                    closeOnClick
                    rtl
                    pauseOnVisibilityChange
                    draggable={false}
                    pauseOnHover/>
            </PersistGate>
        </Provider>
    );
};

export default App;
